import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';
import BulkImport from './index';

const paths = {
  bulkImport: '/inventory/import',
};

export default [
  <RouteIfRights
    exact
    path={paths.bulkImport}
    component={BulkImport}
    key={paths.bulkImport}
    rights="inventory_import"
  />,
];
